import { FC } from 'react'

import { Tooltip } from '@/components/ui/tooltip.tsx'

import ArrowSendIcon from '../../../icons/arrow-light-right.svg'
import { IconButton } from '../../components/icon-button'

interface ChatBlockActionProps {
  onSubmit: () => void
}

export const ChatBlockAction: FC<ChatBlockActionProps> = ({ onSubmit }) => {
  return (
    <Tooltip
      content="Regenerate"
      asChild
    >
      <div
        onClick={onSubmit}
        className="flex items-center gap-2.5 border text-primary-500 rounded-lg hover:bg-primary-500 hover:text-neutral-default cursor-pointer border-border p-4 flex-shrink-0"
      >
        <IconButton
          icon={ArrowSendIcon}
          iconClassName="h-6 w-6"
          className="hover:!text-inherit"
        />
      </div>
    </Tooltip>
  )
}
